import React from 'react';
import {connect} from 'react-redux';
import {translate} from 'react-i18next';
import _ from 'lodash';
import {pluck} from 'ramda';
import {submitFetchData} from './SubmitAction';
import moment from 'moment';
import {
	navigationBack,
	resetNavigationToOverview,
} from '../navigation/NavigationActions';
import NoSleep from 'nosleep.js/dist/NoSleep.min';
import InfoSnack from '../utils/InfoSnack';
import {getWorkout, saveWorkout, clearWorkout} from '../utils/workoutStore';
import {colors} from '../styles/colors';
import './WorkoutScreen.css';
import MainWorkoutView from './MainWorkoutView';
import doneSound from './done.mp3';
import almostDoneSound from './321perfect.mp3';
import goSound from './go.mp3';
import {
	getOptionalExcercisesConfig,
	getWantsSounds,
	setWantsSounds,
} from '../utils/settingsStore';
import ConfirmLeaveDialog from './ConfirmLeaveDialog';
import TopLifeWorkoutMenu from './TopLifeWorkoutMenu';
import TopLifeProgressBar from './TopLifeProgressBar';
import GoToNextRoundDialog from './GoToNextRoundDialog';
import SubmitAgainDialog from './SubmitAgainDialog';
import {ReCaptcha} from "react-recaptcha-v3";

let isFromStorage = false;
let refreshIntervalId, stopwatchIntervalId;
let noSleep = new NoSleep();

const defaultState = {
	dialogOpen: false,
	itemIndex: 0,
	activeExcerciseId: '',
	nextExcerciseId: '',
	activeExcerciseStartTime: '',
	activeExcerciseEndTime: '',
	workoutCompletionData: [],
	clock: '00:00',
	wantsSound: !!getWantsSounds(),
	anchorEl: null,
	isMenuOpen: false,
	warmupDialogOpen: false,
	cooldownDialogOpen: false,
	rounds: 0,
	excercises: [],
	workoutId: '',
	retryDialogOpen: false,
};
class WorkoutScreen extends React.PureComponent {
	constructor(props) {
		super(props);
		const savedWorkout = getWorkout();
		if (!savedWorkout) {
			const todaysExercises = this.getAllForToday(props.workout);
			this.state = {
				...defaultState,
				rounds: this.props.workout.rounds,
				workoutId: this.props.workout._id,
				excercises: todaysExercises,
				end_deadline: this.props.workout.end_deadline,
			};
		}

		if (!!savedWorkout) {
			if (props.workout && props.workout._id) {
				const {_id} = props.workout;
				const {workoutId} = savedWorkout;
				if (_id === workoutId) {
					this.state = getWorkout();
					return;
				} else {
					clearWorkout();
					const todaysExercises = this.getAllForToday(props.workout);
					this.state = {
						...defaultState,
						excercises: todaysExercises,
						rounds: this.props.workout.rounds,
						workoutId: this.props.workout._id,
						end_deadline: this.props.workout.end_deadline,
					};
				}
			} else {
				this.state = getWorkout();
			}
		}
	}

	getNextClock = () => {
		const nextExcercise = this.nextExcercise();
		if (nextExcercise) {
			if (nextExcercise.excercise_info.name === 'Pause') return '00:00';

			const {
				excercise_info: {duration},
			} = nextExcercise;
			return duration ? `00:${duration}` : '00:00';
		}
	};
	undoExercise = () => {
		const itemIndex = this.state.itemIndex - 1;
		const workoutCompletionData = this.state.workoutCompletionData.slice(
			0,
			this.state.workoutCompletionData.length - 1
		);
		this.resetTimeTracking();
		this.setState(
			{
				itemIndex,
				workoutCompletionData,
				activeExcerciseEndTime: '',
				activeExcerciseStartTime: '',
				activeExcerciseId: '',
				clock: '00:00',
				anchorEl: null,
				isMenuOpen: false,
			},
			() => {
				this.saveProgress();
			}
		);
	};
	currentExcercise = () => {
		const {itemIndex, excercises} = this.state;
		return excercises[itemIndex];
	};

	nextExcercise = () => {
		const {itemIndex, excercises} = this.state;
		return excercises[itemIndex + 1];
	};

	isCurrentExercicseTimed = () => {
		const currentExcercise = this.currentExcercise();
		if (!currentExcercise) return;
		const {
			excercise_info: {duration},
		} = this.currentExcercise();
		return !!duration;
	};

	getCurrentExerciseDuration = () => {
		const {
			excercise_info: {duration},
		} = this.currentExcercise();
		return duration;
	};
	startCurrentExcercise = () => {
		const {
			_id,
			excercise_info: {duration, reps, name},
		} = this.currentExcercise();
		const isPause = name === 'Pause';
		if (!!duration || !!reps || isPause) {
			this.setState({
				activeExcerciseId: _id,
			});
			if (duration) return this.startTimer(duration);
			return this.startStopwatch();
		}
	};
	onCtaPress = () => {
		const currentExcercise = this.currentExcercise();
		if (stopwatchIntervalId) {
			return this.stopStopwatch();
		}
		if (currentExcercise && this.isWaitingForStart()) {
			this.startCurrentExcercise();
		}
	};

	getCtaText = () => {
		const currentExcercise = this.currentExcercise();

		if (!currentExcercise) return '';
		const {
			activeExcerciseId,
			activeExcerciseEndTime,
			activeExcerciseStartTime,
		} = this.state;

		if (activeExcerciseId && this.isCurrentExercicseTimed()) {
			return '';
		}

		const workoutInProgress =
			!activeExcerciseEndTime && activeExcerciseStartTime;
		const {duration, reps, name} = currentExcercise.excercise_info;
		const {t} = this.props;

		if (this.isLastExercise() && workoutInProgress) {
			return this.props.t('workout:endWorkout');
		}
		if (name === 'Pause') {
			return this.props.t('workout:finishPause');
		}
		if (duration) {
			if (workoutInProgress) {
				return '';
			}
			return t('workout:start');
		}
		if (reps) {
			if (!workoutInProgress) {
				return t('workout:start');
			} else {
				return t('workout:end');
			}
		}
	};

	getAllForToday = (workout) => {
		if (!workout) return [];
		if (!Object.keys(workout).length) return [];
		const {wantsCooldown, wantsWarmup} = getOptionalExcercisesConfig();
		const {cooldowns, warmups, excercises} = workout;

		return [
			...(wantsWarmup ? warmups : []),
			...excercises,
			...(wantsCooldown ? cooldowns : []),
		];
	};

	isLastExercise = () => {
		return this.state.excercises.length === this.state.itemIndex + 1;
	};

	areAllCompleted = () => {
		const {length: toSubmitCount} = this.state.workoutCompletionData;
		const {length: allExcercisesCount} = this.state.excercises;
		const lastExerciseInfo = this.state.workoutCompletionData[
			toSubmitCount - 1
		];
		return (
			toSubmitCount === allExcercisesCount &&
			lastExerciseInfo.confirmed_timestamp
		);
	};

	startTimer = (seconds) => {
		const start = moment(new Date());
		this.setState({
			clock: `00:${seconds > 10 ? seconds : `0${seconds}`}`,
			activeExcerciseStartTime: start.toISOString(),
		});

		if (!!getWantsSounds()) {
			try {
				this.goSoundRef.play();
			} catch (error) {}
		}
		refreshIntervalId = setInterval(() => {
			const timeNow = moment(new Date());
			const timeWhenStarted = moment(start);
			const duration = moment.duration(timeNow.diff(timeWhenStarted));
			const secondsElapsed = duration.seconds();
			const timeUntilDone = seconds - secondsElapsed;
			const isAlmostDone = timeUntilDone < 4 && timeUntilDone >= 3;
			if (isAlmostDone && !!getWantsSounds()) {
				if (!!this.almostDoneSoundRef) {
					try {
						this.almostDoneSoundRef.play();
					} catch (error) {}
				}
			}

			if (timeUntilDone < 1) {
				if (this.isLastExercise()) {
					return this.finishAndSubmit();
				}
				this.resetTimeTracking();
				this.setState({
					clock: this.getNextClock(),
					activeExcerciseEndTime: new Date().toISOString(),
					warmupDialogOpen: this.isLastWarmup(),
					cooldownDialogOpen: this.isLastCooldown(),
				});
			} else {
				const nextSeconds = seconds - secondsElapsed;
				this.setState({
					clock: `00:${
						nextSeconds < 10 ? `0${nextSeconds}` : nextSeconds
					}`,
				});
			}
		}, 1000);
	};

	startStopwatch = () => {
		const startTime = moment(new Date());
		this.setState({
			clock: '00:00',
			activeExcerciseStartTime: startTime.toISOString(),
		});

		if (!!getWantsSounds()) {
			try {
				this.goSoundRef.play();
			} catch (error) {}
		}

		stopwatchIntervalId = setInterval(() => {
			const now = moment(new Date());
			const start = moment(startTime);
			const duration = moment.duration(now.diff(start));
			const mins = duration.minutes();
			const secs = duration.seconds();
			const minString = mins < 10 ? `0${mins}` : mins;
			const secString = secs < 10 ? `0${secs}` : secs;
			this.setState({
				clock: `${minString}:${secString}`,
			});
		}, 1000);
	};
	stopStopwatch = () => {
		if (stopwatchIntervalId) {
			if (!!getWantsSounds()) {
				try {
					this.doneSoundRef.play();
				} catch (error) {}
			}
			if (this.isLastExercise()) {
				return this.finishAndSubmit();
			}
			const activeExcerciseEndTime = moment(new Date()).toISOString();
			this.resetTimeTracking();
			this.setState({
				clock: this.getNextClock(),
				activeExcerciseEndTime,
				warmupDialogOpen: this.isLastWarmup(),
				cooldownDialogOpen: this.isLastCooldown(),
			});
		}
	};

	resetTimeTracking = () => {
		if (refreshIntervalId) {
			clearInterval(refreshIntervalId);
			refreshIntervalId = undefined;
		}
		if (stopwatchIntervalId) {
			clearInterval(stopwatchIntervalId);
			stopwatchIntervalId = undefined;
		}
	};
	finishAndSubmit = () => {
		this.resetTimeTracking();
		this.setState(
			{
				activeExcerciseEndTime: new Date().toISOString(),
				clock: this.getNextClock(),
			},
			() => {
				this.saveProgress();
				this.submitWorkoutData();
			}
		);
	};
	submitWorkoutData = () => {
		this.props.submitFetchData(
			this.state.workoutId,
			this.state.workoutCompletionData,
			this.props.userOnTrack
		);
	};

	componentWillUnmount() {
		noSleep.disable();
		this.resetTimeTracking();
		//sectionDataSource = [];
	}
	componentDidUpdate(prevProps) {
		const {
			activeExcerciseEndTime,
			activeExcerciseStartTime,
			activeExcerciseId,
		} = this.state;
		const isCompleted =
			!!activeExcerciseEndTime && !!activeExcerciseStartTime;

		// check to see if excercise has just finished
		// will have both times, finish and start
		// as well as the id
		// if finsihed - go to next state and save workout progress
		if (isCompleted && activeExcerciseId) {
			const {itemIndex} = this.state;
			this.setState(
				{
					itemIndex: itemIndex + 1,
					activeExcerciseId: '',
					activeExcerciseStartTime: '',
					activeExcerciseEndTime: '',
					workoutCompletionData: [
						...this.state.workoutCompletionData,
						{
							_id: activeExcerciseId,
							start_timestamp: activeExcerciseStartTime,
							confirmed_timestamp: activeExcerciseEndTime,
						},
					],
				},
				() => {
					this.saveProgress();
				}
			);
		}
		const currentExcercise = this.currentExcercise();
		if (
			currentExcercise &&
			currentExcercise.position === 99 &&
			this.isWaitingForStart()
		) {
			this.startCurrentExcercise();
		}

		this.initNetworkError(prevProps);
	}

	componentWillMount() {
		noSleep.enable();
		window.scrollTo(0, 0);
		if (!this.props.workout.excercises && !getWorkout()) {
			this.props.goToOverview();
		}
	}

	initNetworkError(prevProps) {
		if (
			prevProps.loadingSubmitFailed !== this.props.loadingSubmitFailed &&
			prevProps.submitLoading
		) {
			if (this.infoSnack) {
				this.infoSnack.showSnack(this.props.t('common:cell_failed'));
			}
			this.setState({retryDialogOpen: true}, () => {
				this.saveProgress();
			});
		} else if (
			prevProps.submitAlreadyMissed !== this.props.submitAlreadyMissed &&
			prevProps.submitLoading
		) {
			if (this.infoSnack) {
				this.infoSnack.showSnack(this.props.t('common:alreadyMissed'));
			}
			this.props.goToOverview();
		}
	}

	_isFirst() {
		return this.state.itemIndex === 0;
	}
	handleCloseDialog = () => {
		this.setState({dialogOpen: false});
	};

	askBeforeLeave = () => {
		if (this._isFirst()) {
			this.props.goBack();
		} else {
			this.setState({dialogOpen: true, isMenuOpen: false});
		}
	};

	itemDone = (itemId) => {
		for (let i = 0; i < this.state.submitWorkout.length; i++) {
			let item = this.state.submitWorkout[i];
			if (item._id === itemId) {
				return true;
			}
		}
		return false;
	};

	hasJustFinishedExcercise = () => {
		if (!Array.isArray(this.state.submitWorkout)) {
			return false;
		}

		return !!this.state.submitWorkout.find(
			({_id}) => _id === this.state.selectedItemId
		);
	};

	getTimeElapsedAsPercentage = () => {
		const exercise = this.currentExcercise();
		if (
			!exercise ||
			!exercise.excercise_info ||
			!exercise.excercise_info.duration
		) {
			return;
		}
		const {activeExcerciseStartTime} = this.state;
		const {
			excercise_info: {duration},
		} = exercise;
		if (!activeExcerciseStartTime) return;
		if (activeExcerciseStartTime) {
			const timeWhenStarted = moment(activeExcerciseStartTime);
			const timeNow = moment(new Date().toISOString());
			const elapsed = moment
				.duration(timeNow.diff(timeWhenStarted))
				.seconds();
			const elapsedAsPercentage = (elapsed / duration) * 100;
			return Math.floor(elapsedAsPercentage);
		}
	};

	handleSetSound = () => {
		const newSoundPreference = !this.state.wantsSound;
		setWantsSounds(newSoundPreference);
		this.setState({
			wantsSound: newSoundPreference,
			anchorEl: null,
			isMenuOpen: false,
		});
	};

	handleMenuClose = () => {
		this.setState({anchorEl: null, isMenuOpen: false});
	};
	handleMenuOpen = (event) => {
		this.setState({anchorEl: event.currentTarget, isMenuOpen: true});
	};
	getCurrentRoundExcercises = () => {
		const currentExcercise = this.currentExcercise();
		if (!currentExcercise) return [];
		const {excercises} = this.state;
		const {
			round: currentRound,
			position,
			excercise_info: {type},
		} = this.currentExcercise();
		const excercisesInRound = excercises.filter((x) => {
			if ([position].includes(99)) {
				return (
					x.round === currentRound &&
					!['warmup', 'cooldown'].includes(x.excercise_info.type)
				);
			}

			if (x.position === 99 && !['warmup', 'cooldown'].includes(type)) {
				return x.round === currentRound;
			}

			return x.round === currentRound && x.excercise_info.type === type;
		});

		return excercisesInRound;
	};
	getNumOfExcercisesInCurrentRound = () => {
		return this.getCurrentRoundExcercises().length;
	};

	getNumOfCompletedForCurrentRound = () => {
		const {workoutCompletionData} = this.state;
		const completedIds = pluck('_id', workoutCompletionData);
		const excercisesForRound = this.getCurrentRoundExcercises();
		return excercisesForRound.filter(({_id}) => completedIds.includes(_id))
			.length;
	};

	isLastWarmup = () => {
		// cooldo: cooldown
		const currentExcercise = this.currentExcercise();
		if (!currentExcercise) {
			return;
		}
		const {
			excercise_info: {type},
		} = currentExcercise;
		if (type === 'warmup') {
			return (
				this.getNumOfExcercisesInCurrentRound() - 1 ===
				this.getNumOfCompletedForCurrentRound()
			);
		}
	};
	isLastCooldown = () => {
		const currentExcercise = this.currentExcercise();
		const nextExcercise = this.nextExcercise();
		if (!currentExcercise || !nextExcercise) {
			return;
		}
		const {
			excercise_info: {type},
		} = currentExcercise;
		const {
			excercise_info: {type: nextType},
		} = nextExcercise;
		return type === 'workout' && nextType === 'cooldown';
	};

	isWaitingForStart = () => {
		const {
			activeExcerciseId,
			activeExcerciseStartTime,
			activeExcerciseEndTime,
		} = this.state;
		return (
			!activeExcerciseId &&
			!activeExcerciseStartTime &&
			!activeExcerciseEndTime
		);
	};
	onVideoLoadFinish = () => {
		this.setState({
			isLoadingVideo: false,
		});
	};
	onVideoLoadStart = () => {
		this.setState({
			isLoadingVideo: true,
		});
	};
	saveProgress = () => {
		saveWorkout({
			...this.state,
			anchorEl: null,
			dialogOpen: false,
			isMenuOpen: false,
			activeExcerciseEndTime: '',
			activeExcerciseStartTime: '',
			clock: '00:00',
			activeExcerciseId: '',
		});
	};
	render() {
		if (!this.props.workout.excercises && !getWorkout()) {
			return <div>{this.props.t('workout:errorTech')}</div>;
		}
		const nextExcercise = this.nextExcercise();
		const currentExcercise = this.currentExcercise();
		const {t} = this.props;
		return (
			<div
				style={styles.container}
				className='workoutScreenWrapper noSelectAtAll'
			>
				<ReCaptcha
					sitekey="6Lc-2_gUAAAAAL9yUANfRxC2hRbPFI0jTvlvVQPB"
					action='workout_screen'
				/>
				<InfoSnack onRef={(ref) => (this.infoSnack = ref)} />
				<GoToNextRoundDialog
					isOpen={this.state.warmupDialogOpen}
					title={t('workout:roundFinished', {round: 'Warmup'})}
					ctaText={t('workout:toRound', {round: 'Workout'})}
					onCtaPress={() => {
						this.setState({
							warmupDialogOpen: false,
						});
					}}
				/>
				<GoToNextRoundDialog
					isOpen={this.state.cooldownDialogOpen}
					title={t('workout:roundFinished', {round: 'Workout'})}
					ctaText={t('workout:toRound', {round: 'Cooldown'})}
					onCtaPress={() => {
						this.setState({
							cooldownDialogOpen: false,
						});
					}}
				/>
				<SubmitAgainDialog
					isOpen={this.state.retryDialogOpen}
					title={t('workout:submitFailed')}
					ctaText={t('overview:retry')}
					ctaLoading={this.props.submitLoading}
					onCtaPress={() => {
						this.submitWorkoutData();
					}}
				/>
				<ConfirmLeaveDialog
					t={this.props.t}
					isOpen={this.state.dialogOpen}
					onClose={this.handleCloseDialog}
					goBack={this.props.goBack}
					onContinueLaterSelect={this.saveProgress}
				/>
				<audio
					ref={(input) => {
						this.doneSoundRef = input;
					}}
					src={doneSound}
				></audio>
				<audio
					ref={(input) => {
						this.almostDoneSoundRef = input;
					}}
					src={almostDoneSound}
				></audio>
				<audio
					ref={(input) => {
						this.goSoundRef = input;
					}}
					src={goSound}
				></audio>
				<div className='workout-view-outter-wrapper'>
					<TopLifeProgressBar
						currentExcercise={currentExcercise}
						time={this.state.clock}
						isMenuOpen={this.state.isMenuOpen}
						handleOpenMenu={this.handleMenuOpen}
						excercisesInCurrentRoundCount={this.getNumOfExcercisesInCurrentRound()}
						excercisesInCurrentRoundCompleted={this.getNumOfCompletedForCurrentRound()}
						totalRounds={this.state.rounds}
					/>
					<MainWorkoutView
						onVideoLoadFinish={this.onVideoLoadFinish}
						onVideoLoadStart={this.onVideoLoadStart}
						isLoadingVideo={this.state.isLoadingVideo}
						ctaText={this.getCtaText()}
						isWaitingForStart={this.isWaitingForStart()}
						currentExcercise={currentExcercise}
						nextExcercise={
							!this.isLastWarmup() &&
							!this.isLastCooldown() &&
							nextExcercise
						}
						// cooldo: cooldown
						t={this.props.t}
						handleCtaPress={this.onCtaPress}
						excerciseProgress={this.getTimeElapsedAsPercentage()}
					/>
				</div>
				<TopLifeWorkoutMenu
					anchorEl={this.state.anchorEl}
					handleCloseMenu={this.handleMenuClose}
					open={this.state.isMenuOpen}
					onCloseWorkoutPress={this.askBeforeLeave}
					onUndoPress={this.undoExercise}
					onSoundControlPress={this.handleSetSound}
					isUndoDisabled={this._isFirst()}
					t={this.props.t}
					wantsSound={this.state.wantsSound}
				/>
				{nextExcercise && (
					<CachedVideoLoad src={nextExcercise.excercise_info.video} />
				)}
			</div>
		);
	}
}

function CachedVideoLoad({src}) {
	return (
		<video
			style={{
				opacity: 0,
				position: 'absolute',
				height: 1,
				width: 1,
			}}
			src={src}
		/>
	);
}

const styles = {
	containerShadowBox: {
		maxWidth: 1200,
		margin: '0 auto',
		paddingTop: 121,
	},
	container: {},
	flex: {
		display: 'flex',
		flex: 1,
		justifyContent: 'flex-end',
	},
	title: {
		flex: 1,
		textAlign: 'center',
	},
	workingInline: {
		paddingTop: 121,
		marginTop: -121,
	},
	discardButton: {
		paddingTop: 30,
	},
	controlsContainer: {
		backgroundColor: colors.grey,
		width: '100%',
		position: 'fixed',
		zIndex: 99,
		top: 56,
	},
	controlsContent: {
		maxWidth: 1200,
		margin: '0 auto',
		display: 'flex',
		backgroundColor: colors.grey,
		paddingLeft: 15,
		paddingRight: 15,
		paddingBottom: 15,
	},
	button: {
		flex: 1,
	},
};

const mapStateToProps = (state) => {
	return {
		workout: state.workout,
		loadingSubmitFailed: state.loadingSubmitFailed,
		submitLoading: state.submitLoading,
		submitAlreadyMissed: state.submitAlreadyMissed,
		userOnTrack: state.userOnTrack,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitFetchData: (dayId, exercises, userOnTrack) =>
			dispatch(submitFetchData(dayId, exercises, userOnTrack)),
		goBack: () => dispatch(navigationBack()),
		goToOverview: () => dispatch(resetNavigationToOverview()),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(translate(['workout', 'common'])(WorkoutScreen));



// WEBPACK FOOTER //
// ./src/workout/WorkoutScreen.js